export default {
  path: {
    d: "M232,128A104,104,0,0,1,79.12,219.82L45.07,231.17a16,16,0,0,1-20.24-20.24l11.35-34.05A104,104,0,1,1,232,128Z",
  },
  properties: {
    viewBox: "0 0 256 256",
    outlined: false,
    strokeWidth: "0",
  },
};
